// utils/myraHelpers.js

const normalizeMyraMessages = (messages = []) =>
    messages.map((msg) => ({
        role: msg.role === "model" ? "assistant" : msg.role ? msg.role : msg.who === "u" ? "user" : "assistant",
        content: msg.content || msg.text || "",
    }));

export function buildLandingScreenPayload(screenName) {
    const screenPayload = {
        gsa_step: screenName,
        active_prompt: "oc",
        user_name: localStorage.getItem("self_name") || "",
    };

    const landingChat = window.landing_chat || [];
    const landingHistory = window.landingHistory || [];
    const normalizedLandingChat = normalizeMyraMessages(landingChat);
    const normalizedLandingHistory = normalizeMyraMessages(landingHistory);

    let finalLandingChat = [];
    if (normalizedLandingChat.length && normalizedLandingHistory.length) {
        finalLandingChat = [...normalizedLandingHistory, ...normalizedLandingChat];
    } else if (normalizedLandingChat.length) {
        finalLandingChat = normalizedLandingChat;
    } else if (normalizedLandingHistory.length) {
        finalLandingChat = normalizedLandingHistory;
    }

    if (finalLandingChat.length) {
        screenPayload.landing_chat = finalLandingChat;
    }

    return screenPayload;
}

export function persistLandingMessage(role, content) {
    const entry = { role, content };
    window.landing_chat = [...(window.landing_chat || []), entry];
    try {
        localStorage.setItem("landing_chat", JSON.stringify(window.landing_chat));
    } catch (e) {
        // storage full/unavailable — non-fatal, in-memory window.landing_chat still works
    }
}